import {
  bnyTopicGroupEmitter,
  bnyTopicTenantEmitter,
  bnyTopicUserEmitter,
} from './webSocketEmitter';

const subscriber = {};

export const initializeGlobalSubscriber = (action, setNotificationData) => {
  subscriber['bnyTopicTenant'] = bnyTopicTenantEmitter.subscribe({
    next: (notification: any) => {
      // setNotificationData();
    },
  });

  subscriber['bnyTopicGroup'] = bnyTopicGroupEmitter.subscribe({
    next: (notification: any) => {
      const { type } = notification;
      const { getAllOrders, getClosedOrders } = action;
      if (
        [
          'TRADE_CREATED',
          'TRADE_STATUS_UPDATED',
          'TRADE_CANCELLED',
          'BASKET_STATUS_UPDATED',
        ].includes(type)
      ) {
        setNotificationData({
          message: `Swap order is updated`,
        });
        setTimeout(() => {
          getAllOrders();
          getClosedOrders();
        }, 5000);
      }
    },
  });

  subscriber['bnyTopicUser'] = bnyTopicUserEmitter.subscribe({
    next: (notification: any) => {
      // setNotificationData();
    },
  });
};

export const unsubscribeAllGlobally = (subscriptions) => {
  if (subscriptions.constructor === Object) {
    Object.values(subscriptions).forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }
};

export const unsubscribe = () => {
  unsubscribeAllGlobally(subscriber);
};
